import type { GetIdentityContactUsersInput, IdentityUserDtoEx, PasswordResetTokenDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { ListResultDto, PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { GetIdentityUsersInput, IdentityRoleDto, IdentityUserCreateDto, IdentityUserDto, IdentityUserUpdateDto, IdentityUserUpdateRolesDto } from '../../../volo/abp/identity/models';

@Injectable({
  providedIn: 'root',
})
export class IdentityUserAppServiceExService {
  apiName = 'Default';
  

  confirmEmail = (userId: string, token: string, hash: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: `/api/app/identity-user-app-service-ex/confirm-email/${userId}`,
      params: { token, hash },
    },
    { apiName: this.apiName,...config });
  

  confirmMobilePasswordResetRequest = (mobileNumber: string, otp: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PasswordResetTokenDto>({
      method: 'POST',
      url: '/api/app/identity-user-app-service-ex/confirm-mobile-password-reset-request',
      params: { mobileNumber, otp },
    },
    { apiName: this.apiName,...config });
  

  confirmPhone = (username: string, code: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/identity-user-app-service-ex/confirm-phone',
      params: { username, code },
    },
    { apiName: this.apiName,...config });
  

  create = (input: IdentityUserCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'POST',
      url: '/api/app/identity-user-app-service-ex',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/identity-user-app-service-ex/${id}`,
    },
    { apiName: this.apiName,...config });
  

  findByEmail = (email: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'POST',
      url: '/api/app/identity-user-app-service-ex/find-by-email',
      params: { email },
    },
    { apiName: this.apiName,...config });
  

  findByUsername = (userName: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'POST',
      url: '/api/app/identity-user-app-service-ex/find-by-username',
      params: { userName },
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'GET',
      url: `/api/app/identity-user-app-service-ex/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getAssignableRoles = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ListResultDto<IdentityRoleDto>>({
      method: 'GET',
      url: '/api/app/identity-user-app-service-ex/assignable-roles',
    },
    { apiName: this.apiName,...config });
  

  getContactUsersList = (input: GetIdentityContactUsersInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdentityUserDto>>({
      method: 'GET',
      url: '/api/app/identity-user-app-service-ex/contact-users-list',
      params: { contactId: input.contactId, filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount, extraProperties: input.extraProperties },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetIdentityUsersInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdentityUserDto>>({
      method: 'GET',
      url: '/api/app/identity-user-app-service-ex',
      params: { filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount, extraProperties: input.extraProperties },
    },
    { apiName: this.apiName,...config });
  

  getListEx = (input: GetIdentityUsersInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdentityUserDtoEx>>({
      method: 'GET',
      url: '/api/app/identity-user-app-service-ex/ex',
      params: { filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount, extraProperties: input.extraProperties },
    },
    { apiName: this.apiName,...config });
  

  getRoles = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ListResultDto<IdentityRoleDto>>({
      method: 'GET',
      url: `/api/app/identity-user-app-service-ex/${id}/roles`,
    },
    { apiName: this.apiName,...config });
  

  sendConfirmEmailCode = (userId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/identity-user-app-service-ex/send-confirm-email-code/${userId}`,
    },
    { apiName: this.apiName,...config });
  

  sendConfirmPhoneCode = (username: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/identity-user-app-service-ex/send-confirm-phone-code',
      params: { username },
    },
    { apiName: this.apiName,...config });
  

  sendMobilePasswordResetCode = (username: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/identity-user-app-service-ex/send-mobile-password-reset-code',
      params: { username },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: IdentityUserUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'PUT',
      url: `/api/app/identity-user-app-service-ex/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  updateRoles = (id: string, input: IdentityUserUpdateRolesDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'PUT',
      url: `/api/app/identity-user-app-service-ex/${id}/roles`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
